/* 
Props Definition-
getActiveList - List to show in dropdown options
activeFilters - active filters if any, to prefill in field by extracting relevant information
activeElement - activeItem if any, in case of modalState="Edit" to prefill in field by extracting relevant information
getActiveItemById - redux function to get active item by id, in case of edit state (in order to extract name to pair it with id)
nextPage - redux state, in order to show pagination or not (can be used in both CastForEducationSharp, if there is no pagination, nextPage will be -1, so it will not show)
resKey - response key that contains the required list
modalState - active modal state of modal or form
keyName - name of key having id to map the options
labelKey - name of key contains "name" or any parameter to pair it with id, to map them as object like {id : "", name : ""} in options, if want to map on one key only, like name only, then pass labelKey same as keyName
getDataLabelKey - name of key to get data from api using getDataById (like country.country_name)
keyTypeToSet - key to set from options, suppose in options object, id is coming, so pass "id", then it will set options[0].id to keyName
disabled - If disable the Component
stateDependent- If onchange has to change to state of component, not nested one
label - Label or name of the dropdown component
handleChange - function to set the value of field having name as keyName
remoteSearchApplicable - to give the functionality of remote search, set to true, otherwise false
remoteSearchKey - if remoteSearchApplicable is set to true, then pass remoteSearchKey on which you to apply the search, (basically the key you want to send in the api to fetch results prefixed with the value of dropdown)
*/

import React, { useState, useEffect } from "react";
import { getPath, debounce, throttle } from "../../../utils";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
import styled from "styled-components";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const CustomAutocomplete = styled(Autocomplete)`
  width: fit-content;

  .MuiInputBase-root {
    background-color: #fff;
  }
`;

const scrollOffset = 10;

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "none",
    color: "red",
    fontSize: 10,
  },
}));
const AutoComplete = (props) => {
  const {
    getActiveList,
    resKey,
    keyName,
    keyTypeToSet,
    labelKey,
    handleChange,
    label,
    remoteSearchApplicable,
    isStringList,
    id,
    labels = [],
    makeNoInitialCall,
    value,
    extraParams = [],
    allowDuplicateOptions,
    tooltip,
    activeListExtraParam,
  } = props;

  const defaultActiveItemValue = isStringList ? "" : {};
  const [currList, setCurrList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeItem, setActiveItem] = useState(defaultActiveItemValue);
  const removeDuplicates = (arr) => {
    if (isStringList) {
      return [...new Set(arr)];
    }
    const newArr = [];
    const set = new Set();
    arr.forEach((obj) => {
      if (set.has(obj.id) === false) {
        set.add(obj.id);
        newArr.push(obj);
      }
    });
    return newArr;
  };
  const updateState = throttle(() => {
    if (props.disabled) {
      return;
    }
    setIsLoading(true);
    setTimeout(() => {
      getActiveList(activeListExtraParam)
        .then((res) => {
          let newList = getPath(res, resKey, []);
          if (newList.length > 0) {
            newList = allowDuplicateOptions
              ? [...currList, ...newList]
              : removeDuplicates([...currList, ...newList]);
            setCurrList(newList);
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log("Error", err);
          setIsLoading(false);
        });
    }, 500);
  }, 500);

  const getLabelFromLabelsProp = (option) => {
    let label1 = option[labels[1]] || option["entityValue"];
    return `${option[labels[0]]} (${labels[1]} : ${label1})`;
  };

  useEffect(() => {
    setActiveItem(defaultActiveItemValue);
    !makeNoInitialCall &&
      getActiveList(activeListExtraParam).then((res) => {
        const newList = getPath(res, resKey, []);
        if (newList.length > 0) {
          const tempList = [...newList];
          setCurrList(tempList);
        }
      });
  }, [activeListExtraParam]);

  const handleInputChange = debounce((val) => {
    getActiveList(activeListExtraParam).then((res) => {
      const newList = getPath(res, resKey, []);
      if (newList.length > 0) {
        setCurrList([...newList]);
      }
    });
  }, 500);
  return (
    <CustomAutocomplete
      style={{ width: "fit-content", backgroundColor: "#fff !important" }}
      id={id}
      data-testid="custom-autocomplete-dropdown"
      getOptionSelected={(opt, val) => opt.id === val.id}
      options={currList}
      getOptionLabel={(option) => {
        return (
          (labels.length > 0 && Object.keys(option).length > 0
            ? getLabelFromLabelsProp(option)
            : option[labelKey]) ||
          option ||
          ""
        );
      }}
      popupIcon={isLoading ? <CircularProgress size={25} /> : <ArrowDropDown />}
      renderInput={(params) => {
        if (tooltip) {
          return (
            <LightTooltip placement={tooltip.placement} title={tooltip.title}>
              <TextField
                {...params}
                className="custom-input-base"
                label={label}
                variant="outlined"
              />
            </LightTooltip>
          );
        }
        return (
          <TextField
            {...params}
            className="custom-input-base"
            label={label}
            variant="outlined"
          />
        );
      }}
      ListboxProps={{}}
      onInputChange={(evt, val) => {
        remoteSearchApplicable && handleInputChange(val);
      }}
      onChange={(evt, val) => {
        if (val) {
          setActiveItem(val);
          if (isStringList) {
            return handleChange(keyName, val, [...extraParams], val);
          }
          handleChange(keyName, val[keyTypeToSet], [...extraParams], val);
        } else {
          setActiveItem(defaultActiveItemValue);
          handleChange(keyName, "", [...extraParams], val);
        }
      }}
      closeIcon={<CrossCircle className="cross" />}
      value={value || activeItem}
    />
  );
};

export default AutoComplete;
